import React from "react";
import "./TemplateMarketplace.css";
import CamplaCoreService from "../../services/CamplaCoreService";
import MarkDownViewer from "../../components/markdownViewer/MarkDownViewer";
import StorageService from "../../services/StorageService";

import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop, faEllipsisH, faGlobe, faPlus, faSearch, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import APIErrorHelper from "../../helpers/APIErrorHelper";
import { withTranslation } from "react-i18next";
import TagSelection from "../../components/tagSelection/TagSelection";
import TemplateSearch from "../../components/templateSearch/TemplateSearch";

class TemplateMarketplace extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      instanceTemplates: [],
      selectedTags: [],
      errorMessage: "",
      dialogApiError: "",
      apiError: ""
    };

    this.templateTypes = [
      { icon: faDesktop, title: "TemplateMarketplace.TypeVM" },
      { icon: faGlobe, title: "TemplateMarketplace.TypeOnline" },
      { icon: faFilePdf, title: "TemplateMarketplace.TypeLocal" }
    ];

    this.loadData = this.loadData.bind(this);
    this.handleTemplateClick = this.handleTemplateClick.bind(this);
    this.handleSelectedTagsChange = this.handleSelectedTagsChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadCachedData = this.loadCachedData.bind(this);
    this.showApiError = this.showApiError.bind(this);
  }

  async componentDidMount() {
    this.loadCachedData();
    this.setState(await this.loadData());
  }

  showApiError(err) {
    this.setState({
      dialogApiError: APIErrorHelper.getError(
        err,
        () => this.setState({ dialogApiError: "", validationResult: "" }),
        {
          PRECONDITION_FAILED: "InstanceTemplates.APIError.PreconditionFailed",
          CONFLICT: "InstanceTemplates.APIError.CreateConflict"
        },
        this.props.t
      )
    });
  }

  loadCachedData() {
    const instanceTemplates = StorageService.getReferenceType(
      "instanceTemplates"
    );
    if (instanceTemplates) {
      this.setState({
        instanceTemplates
      });
    }
  }

  async loadData(tags) {
    try {
      let instanceTemplates = [];
      if (tags && tags.length > 0) {
        instanceTemplates = await CamplaCoreService.getInstanceTemplatesByTags(tags);
      } else {
        instanceTemplates = await CamplaCoreService.getAllInstanceTemplates();
        StorageService.set("instanceTemplates", instanceTemplates);
      }
      return {
        instanceTemplates
      };
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        )
      });
    }
    return {
      instanceTemplates: []
    };
  }

  async handleSelectedTagsChange(selectedTags) {
    this.setState({ selectedTags: selectedTags || [] });
    this.setState(await this.loadData(selectedTags || []));
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  handleTemplateClick(instanceId) {
    window.location.href = "/examinations?create=" + instanceId;
  }

  render() {
    const { t } = this.props;

    const customStyles = {
      option: (provided) => ({
        ...provided
      }),
      multiValue: provided => ({
        ...provided,
        paddingLeft: "0.4em",
        paddingRight: "0.4em",
        backgroundColor: "#1E1E26"
      }),
      control: () => ({}),
      valueContainer: provided => ({
        ...provided,
        padding: "0",
        paddingLeft: "0",
        paddingRight: "0",
        marginTop: "5px"
      }),
      multiValueLabel: provided => ({
        ...provided,
        color: "#FFFFFF"
      }),
      singleValue: (provided) => ({ ...provided })
    };

    const templates = this.state.instanceTemplates.map(instanceTemplate => (
      <div className="one-em-padding">
        <Row className="markdownRow">
          <Col className="one-em-padding">
            <Row style={{ width: "" }}>
              <div className="innerMarkdownContainer">
                <MarkDownViewer
                  defaultlanguage="en"
                  text={instanceTemplate.description}
                  readMoreText={t("TemplateMarketplace.ReadMore")}
                  showMaxLines={6}
                />
              </div>
            </Row>
            <Row className="dividerRow" />
            <Row className="tags-row">
              <Col xs={1} className="vr">
                <FontAwesomeIcon
                  title={typeof this.templateTypes[instanceTemplate.type] !== "undefined" ?
                    t(this.templateTypes[instanceTemplate.type].title) : t("TemplateMarketplace.NoType")}
                  icon={typeof this.templateTypes[instanceTemplate.type] !== "undefined" ?
                    this.templateTypes[instanceTemplate.type].icon : faEllipsisH} />
              </Col>
              <Col xs={11}>
                <TagSelection
                  max={10}
                  selectedTags={instanceTemplate.tags}
                  value={instanceTemplate.tags}
                  isDisabled={true}
                  styles={customStyles}
                  components={{
                    DropdownIndicator: () => null,
                    MultiValueRemove: () => null,
                    IndicatorSeparator: () => null
                  }}
                />
              </Col>
            </Row>
          </Col>
          <Button
            className="btn-green btn-green-left-sharp"
            onClick={() => this.handleTemplateClick(instanceTemplate._id)}
          >
            <FontAwesomeIcon icon={faPlus} />
          </Button>
        </Row>
      </div>
    ));

    return (
      <div>
        {this.state.apiError ? (
          <Row>
            <Col>{this.state.apiError}</Col>
          </Row>
        ) : (
          ""
        )}
        <Container className="mt-3">
          <Row className="pageTitle">
            <Col>
              <h2>{t("TemplateMarketplace.Title")}</h2>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form onSubmit={this.handleSubmit}>
                <Form.Group className="mb-3" controlId="search.Search">
                  <TemplateSearch
                    selectedTags={this.state.selectedTags}
                    onChange={this.handleSelectedTagsChange}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null
                    }}
                  />
                  {this.state.selectedTags.length === 0 ?
                      <FontAwesomeIcon icon={faSearch} className="search-icon" /> : ""}
                </Form.Group>
              </Form>
            </Col>
          </Row>
          {templates}
        </Container>
      </div>
    );
  }
}

export default withTranslation()(TemplateMarketplace);
